import { AfterContentChecked, Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { StockCategory } from '../../../../../core/api/api';
import { VolatileStockItem } from '../../../../../core/api/api.entities';
import { StockItemsApi } from '../../../../../core/api/stock-items/stock-items-api.service';
import { columns } from '../../../../../shared/constants/columns.constants';
import { links } from '../../../../../shared/constants/links.constants';
import { formatStockAmount } from '../../../../../shared/utils/formatters.utils';
import { StockOverview } from '../../models/stock-overview.model';

@Component({
  selector: 'app-dashboard-volatile-stock',
  templateUrl: './dashboard-volatile-stock.component.html',
  styleUrl: './dashboard-volatile-stock.component.scss',
})
export class DashboardVolatileStockComponent implements OnInit, AfterContentChecked {
  @ViewChild(MatSort) sort!: MatSort;

  columns = columns.dashboard.volatileStock;
  dataSource = new MatTableDataSource<VolatileStockItem>();
  links = links;
  loading = true;
  formatStockAmount = formatStockAmount;

  constructor(private stockItemsApi: StockItemsApi) {}

  ngOnInit(): void {
    this.loadData();
  }

  ngAfterContentChecked(): void {
    this.dataSource.sort = this.sort;
  }

  get overview(): StockOverview {
    return {
      numberOfDueProducts: this.dataSource.data.filter(item => item.category === StockCategory.Due).length,
      numberOfExpiredProducts: this.dataSource.data.filter(item => item.category === StockCategory.Expired).length,
      numberOfOpenedProducts: this.dataSource.data.filter(item => item.openedAt).length,
      numberOfOverdueProducts: this.dataSource.data.filter(item => item.category === StockCategory.Overdue).length,
      numberOfProducts: this.dataSource.data.length,
    };
  }

  changeSelection(stockCategory: string | null) {
    switch (stockCategory) {
      case 'Opened':
        this.dataSource.filterPredicate = (data, filter) => (data.openedAt ? 'opened' : 'closed') === filter;
        this.dataSource.filter = 'opened';
        break;
      case null:
        this.dataSource.filterPredicate = () => true;
        this.dataSource.filter = '';
        break;
      default:
        this.dataSource.filterPredicate = data => data.category === stockCategory;
        this.dataSource.filter = stockCategory;
        break;
    }
  }

  private loadData(): void {
    this.stockItemsApi.findAllVolatile().subscribe(volatileStock => {
      this.dataSource.data = volatileStock;
      this.loading = false;
    });
  }

  getCurrentStockColourClass(row: VolatileStockItem): string {
    switch (row.category) {
      case StockCategory.Overdue:
        return 'overdue';
      case StockCategory.Due:
        return 'due';
      default:
        return '';
    }
  }
}
